// @ts-nocheck
export const RESOURCES_TYPES = {
  INVOICE: 'invoice',
  ESTIMATE: 'estimate',
  RECEIPT: 'receipt',
  PAYMENT_RECEIVE: 'payment_receive',
  PAYMENT_MADE: 'payment_made',
  CUSTOMER: 'customer',
  VENDOR: 'vendor',
  ITEM: 'item',
  BILL: 'bill',
  EXPENSE: 'expense',
  MANUAL_JOURNAL: 'manual_journal',
  BUDGET: 'budget',
  ACCOUNT: 'account',
  CREDIT_NOTE: 'credit_note',
  VENDOR_CREDIT:'vendor_credit'
};
